import { ajax } from "../settings/settings";

export const getNotice = callback => {
  ajax
    .get("/web/rest/publicNotice")
    .then(function(response) {
      if (response) {
        if (callback) {
          callback(response);
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};

export const getTrans = callback => {
  ajax
    .get("/web/rest/trans")
    .then(function(response) {
      if (response) {
        if (callback) {
          callback(response);
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
};
